import { render, staticRenderFns } from "./HomeProjs.vue?vue&type=template&id=f4e7090e&scoped=true&"
import script from "./HomeProjs.vue?vue&type=script&lang=ts&"
export * from "./HomeProjs.vue?vue&type=script&lang=ts&"
import style0 from "./HomeProjs.vue?vue&type=style&index=0&id=f4e7090e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e7090e",
  null
  
)

export default component.exports